import React from 'react';
import styled from 'styled-components';
import { vars } from '../../theme';
import { useSideNavContext } from '../HBSideNav/context/SideNavProvider';
import { ISideNavTheme } from '../HBSideNav/context/useCreateTheme';

export interface HBWidgetProps {
    /** Controls whether the widget renders in its expanded layout; must be used within an HBSideNav context. */
    isExpanded?: boolean;
    /** Highlights the widget with the active background color from the side nav theme. */
    isActive?: boolean;
    /** Called when the widget is clicked. */
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    children: React.ReactNode;
    /** CSS class applied to the root element. */
    className?: string;
}

const StyledWidget = styled.div<{
    $isExpanded: boolean;
    $isActive: boolean;
    $theme: ISideNavTheme;
}>`
    position: relative;
    border-radius: ${vars.radius.sm};
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: ${props =>
        props.$isActive
            ? props.$theme.activeItemBackgroundColor
            : 'transparent'};
    transition: all 0.2s ease-in-out;

    &:hover {
        cursor: pointer;
        background: ${props =>
            !props.$isActive && props.$theme.itemBackgroundColorHover};
    }
`;

const HBWidget = ({
    isExpanded = true,
    isActive = false,
    onClick,
    children,
    className
}: HBWidgetProps) => {
    const { theme } = useSideNavContext();

    return (
        <StyledWidget
            $isExpanded={isExpanded}
            $isActive={isActive}
            $theme={theme}
            className={className}
            onClick={onClick}
        >
            {children}
        </StyledWidget>
    );
};

export default HBWidget;
